import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AuthenticationService } from '../services/http/authentication.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(
    private authenticationService: AuthenticationService,
  ) { }

  private get databaseName() {
    environment.production = window.location.href.includes('pedidomix.') || window.location.href.includes('mastervariedades.');

    if (environment.production)
    {
      return this.authenticationService.databaseName;
    }
    else
    {
      return 'teste';
    }
  }

  private get token() {
    return this.authenticationService.token;
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    request = request.clone({
      setHeaders: {
        Authorization: `Bearer ${this.token}`,
        DatabaseName: this.databaseName,
        Aplicacao: 'GarcomMobile'
      }
    });

    return next.handle(request);
  }
}
